<template>
  <v-row justify="center">
    <v-col cols="9">
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Importar</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-list class="transparent" dense>
            <v-list-item v-for="d in choices" :key="d.title" style="border-bottom: 1px solid #D8E0EA" :to="{name: d.view}" :ripple="false">
              <v-list-item-content>
                <v-list-item-title class="body-2 text--secondary font-weight-medium">{{d.title}}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn :to="{name: d.view}" text color="primary">Ir a importar<v-icon color="primary" small right>mdi-arrow-right</v-icon></v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
export default {
  data: () => ({
    choices: [
      {
        view: 'AccountImportCustomers',
        title: 'Clientes',
        description: 'Aprende más sobre la importación de clientes.',
        guide: '/docs/settings-imports-customers'
      },
      {
        view: 'ImportUsages',
        title: 'Consumo de planes',
        description: 'Importa los registros de uso para suscripciones en las cuales se cobra por consumo.',
        guide: '/docs/settings-imports-usages'
      }
    ]
  })
}
</script>